export default __webpack_public_path__ + "static/media/Hirschmann.7e0b4078.png";